export default "__VITE_ASSET__bQZrR7j5__"